import { Stepper as BeyondStepper, styled } from '@zeiss/beyond-online-react';

export const Stepper: typeof BeyondStepper = styled(BeyondStepper)`
  /* Reset the background color to match the design */
  & > div {
    background-color: initial;
  }
`;
